import React from 'react';
import {Alert, Button} from "antd";
import {URLS} from "@/lib/urls";
import {Link} from "react-router-dom";
import {InfoCircleOutlined} from "@ant-design/icons";

function LmsLevelIdNeedLoginSection(props) {


    return (

        <div>


            <Alert
                className={'flex flex-wrap'}
                rootClassName={'flex flex-wrap'}
                showIcon={true}
                icon={<InfoCircleOutlined/>}
                message="سلام"
                type="info"
                description={
                    <>
                        برای دسترسی به این مرحله باید وارد سیستم شوید
                        <div className={'m-2'}>
                            <Link to={URLS.auth.login}>
                                <Button size="small" type="primary">
                                    ورود به سیستم
                                </Button>
                            </Link>
                        </div>

                    </>}


            />


        </div>
    );
}

export default LmsLevelIdNeedLoginSection;